<mat-progress-bar class="progress-margin" color="primary" *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<form [formGroup]="formGroup">
    <div class="card-content">
        <div class="full-width">
            <div>
                <app-medical-order-edit-control-component [isReadOnly]="isReadOnly" [disabledValidationOnLine]="disabledValidationOnLine" (onExecuteOnLineOperationClick)="executeOnLineOperation()" #medicalOrderEdit formControlName="MedicalOrderEdit">
                </app-medical-order-edit-control-component>
            </div>
        </div>
    </div>
</form>
